/* tslint:disable */
import * as React from 'react';
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { flow, forEachRight, get, has, forEach } from 'lodash';
import { IBrandingState, II18nMessages } from '../../../../../../services/branding/models';
import { Button, Col, ControlLabel, FormGroup, Row, Alert } from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl/index';
import SelectControl from '../../../../../../components/SelectControl/index';
import FaTrash from 'react-icons/fa/trash';
import * as uuid from 'uuid/v4';
import * as moment from 'moment';
import {
  isAfter,
  isEmail,
  isPhone,
  isPostcode,
  isRequired,
  isValidDate,
  isBefore,
} from '../../../../../../util/validators';
import { IPostcodeAddress, IProduct } from '../../../../../../data/api/models';
import { IStore } from '../../../../../../redux/IStore';
import PostcodeControl from '../../../../../../components/PostcodeControl';

type TravellerType = 'child' | 'adult';

interface ITravellerTypeConfig {
  min: number;
  max: number;
}

interface IGroupType {
  adult: ITravellerTypeConfig;
  child?: ITravellerTypeConfig;
}

interface IGroupTypeMap {
  [type: string]: IGroupType;
}

interface ITripDetailsForm {
  i18n: II18nMessages;
  pristine: boolean;
  fields: any;
  groupType: string;
  travellers: any;
  tripType: string;
  renderDefinition(name: string): any;
  product: IProduct;
  branding: IBrandingState;
  addressSelected?: boolean;
}

const groupTypeTravellerMap: IGroupTypeMap = {
  individual: {
    adult: {
      min: 1,
      max: 10,
    },
    child: {
      min: 0,
      max: 10,
    },
  },
  couple: {
    adult: {
      min: 2,
      max: 2,
    },
    child: {
      min: 0,
      max: 0,
    },
  },
  single_parent_family: {
    adult: {
      min: 1,
      max: 1,
    },
    child: {
      min: 1,
      max: 10,
    },
  },
  family: {
    adult: {
      min: 2,
      max: 2,
    },
    child: {
      min: 1,
      max: 10,
    },
  },
  independent_child: {
    adult: {
      min: 0,
      max: 0,
    },
    child: {
      min: 1,
      max: 10,
    },
  },
};

const defaultTraveller = {
  id: '',
  title: '',
  firstName: '',
  lastName: '',
  dob: '',
  phone: '',
  email: '',
  type: '',
  screening: null,
  screeningSessionId: null,
};

const childTitles = [
  { label: 'Master', value: 'Master' },
  { label: 'Mx', value: 'Mx' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Mr', value: 'Mr' },
];

const adultTitles = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Master', value: 'Master' },
  { label: 'Mx', value: 'Mx' },
  { label: 'Dr', value: 'Dr' },
  { label: 'Prof', value: 'Prof' },
  { label: 'Rev', value: 'Rev' },
  { label: 'Cpt', value: 'Cpt' },
  { label: 'Sir', value: 'Sir' } ,
  { label: 'Dame', value: 'Dame' },
  { label: 'Lord', value: 'Lord' },
  { label: 'Lady', value: 'Lady' },
  { label: 'Rt Honourable', value: 'Rt Honourable' },
];

class Travellers extends React.Component<ITripDetailsForm> {
  private getAll = (type: TravellerType, fields) => fields.getAll().filter((traveller) => traveller.type === type);
  private count = (type: TravellerType, fields) => this.getAll(type, fields).length;
  private handleAddField = (type: TravellerType, fields) => () => this.addField(type, fields);
  private handleRemoveField = (id, fields) => () => this.removeField(id, fields);

  private handleTravellerUpdates = (
      type: TravellerType,
      config: ITravellerTypeConfig,
      fields,
      groupType: string) => {
    let total = this.count(type, fields);

    if ('individual' === groupType && (('adult' === type && total > config.min) || 'child' === type)) {
      forEach(this.getAll(type, fields), (traveller) => {
        this.removeField(traveller.id, fields);
      });
    }

    if (total > config.max) {
      forEachRight(this.getAll(type, fields), (traveller) => {
        if (total <= config.max) {
          return;
        }

        this.removeField(traveller.id, fields);
        total -= 1;
      });
    }

    if (total < config.min) {
      const totalToAdd = config.min - total;

      for (let i = 0; i < totalToAdd; i++) {
        this.addField(type, fields);
      }
    }
  }

  public componentWillReceiveProps(nextProps: ITripDetailsForm) {
    if (this.props.groupType === nextProps.groupType) {
      return;
    }

    const { fields, groupType } = nextProps;
    const config = groupTypeTravellerMap[groupType || 'individual'];

    if (!config) {
      return;
    }

    if (groupType === 'individual') {
      const allTravellers = fields.getAll() || [];

      const leadAdultIndex = allTravellers.findIndex(t => t.type === 'adult');

      fields.removeAll();

      if (leadAdultIndex !== -1) {
        fields.push({
          ...defaultTraveller,
          ...allTravellers[leadAdultIndex],
          type: 'adult',
        });
      } else {
        this.addField('adult', fields);
      }

      return;
    }

    const { adult, child } = config;

    this.handleTravellerUpdates('adult', adult, fields, groupType);
    this.handleTravellerUpdates('child', child, fields, groupType);
  }


  private addField = (type: TravellerType, fields) => {
    fields.push({
      ...defaultTraveller,
      id: uuid(),
      type,
    });
  }

  private getIndex = (id: string, fields) => {
    let travellerIndex = -1;
    const travellers = fields.getAll();

    travellers.forEach((traveller, index) => {
      if (traveller.id === id) {
        travellerIndex = index;
      }
    });

    if (travellerIndex === -1) {
      console.error('Couldn\'t find traveller', travellers, id, travellerIndex);
    }

    return travellerIndex;
  }

  private removeField = (id: string, fields) => {
    const travellerIndex = this.getIndex(id, fields);

    if (travellerIndex === -1) {
      return;
    }

    fields.remove(travellerIndex);
  }

  private handleSelectAddress = (address: IPostcodeAddress) => {
    // @ts-ignore
    const { change, addressSelected } = this.props;
    const base = 'travellers[0].address';
    change(`${base}.line1`, address.line1);
    change(`${base}.line2`, address.line2);
    change(`${base}.town`, address.town);
    change(`${base}.county`, address.county);
    change(`${base}.postcode`, address.postcode);
    if(addressSelected === undefined || !addressSelected) {
      change('addressSelected', true);
    }
  }

  private renderLeadTravellerFields = (traveller, fieldIndex) => {
    const { i18n, branding, addressSelected } = this.props;

    const postcodeValidators = [
      isRequired,
      isPostcode,
    ];
    if (branding.channel.key === 'camc-b2c') {
      return (
          <div>
            <Col sm={12}>
              <FormGroup controlId="phone">
                <Row>
                  <Col sm={6} style={{marginLeft: '15px', marginBottom: '10px'}}>
                    <Field
                        name={`travellers[${fieldIndex}].phone`}
                        type="number"
                        placeholder="Mobile number"
                        component={FieldFormControl}
                        validate={[isRequired, isPhone]}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                    <Field
                        name={`travellers[${fieldIndex}].email`}
                        type="email"
                        placeholder="Email address"
                        component={FieldFormControl}
                        validate={[isRequired, isEmail]}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                    <Field
                        placeholder="Postcode"
                        name={`travellers[${fieldIndex}].address.postcode`}
                        component={PostcodeControl}
                        channel={this.props.branding.channel}
                        onSelectAddress={this.handleSelectAddress}
                        validate={postcodeValidators}
                    />
                  </Col>
                </Row>
                {addressSelected && (
                  <div>
                  <Row>
                    <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                      <Field
                          className="line-top"
                          name="travellers[0].address.line1"
                          placeholder="Line 1"
                          type="text"
                          component={FieldFormControl}
                          validate={[
                            isRequired,
                          ]}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                      <Field
                          className="line-middle"
                          name="travellers[0].address.line2"
                          placeholder="Line 2"
                          type="text"
                          component={FieldFormControl}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                      <Field
                          className="line-middle"
                          name="travellers[0].address.town"
                          type="text"
                          placeholder="Town"
                          component={FieldFormControl}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                      <Field
                          className="line-bottom"
                          name="travellers[0].address.county"
                          placeholder="County"
                          type="text"
                          component={FieldFormControl}
                      />
                    </Col>
                  </Row>
                </div>
                )}
              </FormGroup>
            </Col>
          </div>
      );
    }
    // @ts-ignore
    return (
      <div>
        <Col sm={12}>
          <FormGroup controlId="phone">
            <Col componentClass={ControlLabel} sm={3}>
              *{i18n.quote.tripDetails.traveller.mobile}:
            </Col>
            <Col sm={6}>
              <Field
                name={`travellers[${fieldIndex}].phone`}
                type="number"
                component={FieldFormControl}
                validate={[isRequired, isPhone]}
              />
            </Col>
          </FormGroup>
        </Col>
        <Col sm={12}>
          <FormGroup controlId="email">
            <Col componentClass={ControlLabel} sm={3}>
              *{i18n.quote.tripDetails.traveller.email}:
            </Col>
            <Col sm={6}>
              <Field
                name={`travellers[${fieldIndex}].email`}
                type="email"
                component={FieldFormControl}
                validate={[isRequired, isEmail]}
              />
            </Col>
          </FormGroup>
        </Col>
        {branding.channel.channelType !== 'AGG' && (
          <Col sm={12}>
            <FormGroup controlId="postcode">
              <Col componentClass={ControlLabel} sm={3}>
                *Postcode:
              </Col>
              <Col sm={4}>
                <Field
                  name={`travellers[${fieldIndex}].address.postcode`}
                  component={FieldFormControl}
                  validate={[isRequired, isPostcode]}
                />
              </Col>
            </FormGroup>
          </Col>
        )}
        {branding.channel.channelType === 'AGG' && (
          <Col sm={12}>
            <FormGroup controlId="postcode">
              <Col componentClass={ControlLabel} sm={3}>
                Postcode:
              </Col>
              <Col sm={6}>
                <Field
                  name="travellers[0].address.postcode"
                  type="text"
                  component={PostcodeControl}
                  onSelectAddress={this.handleSelectAddress}
                  validate={[
                    isRequired,
                    isPostcode,
                  ]}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="address">
              <Col componentClass={ControlLabel} sm={3}>
                {i18n.quote.tripDetails.traveller.address}
              </Col>
              <Col sm={6}>
                <Field
                  className="line-top"
                  name="travellers[0].address.line1"
                  placeholder="Line 1"
                  type="text"
                  component={FieldFormControl}
                  validate={[
                    isRequired,
                  ]}
                />
                <Field
                  className="line-middle"
                  name="travellers[0].address.line2"
                  placeholder="Line 2"
                  type="text"
                  component={FieldFormControl}
                />
                <Field
                  className="line-middle"
                  name="travellers[0].address.town"
                  type="text"
                  placeholder="Town"
                  component={FieldFormControl}
                />
                <Field
                  className="line-bottom"
                  name="travellers[0].address.county"
                  placeholder="County"
                  type="text"
                  component={FieldFormControl}
                />
              </Col>
            </FormGroup>
          </Col>
        )}
      </div>
    );
  }

  private renderFields(type: TravellerType) {
    const { fields, i18n, groupType, branding } = this.props;
    const hasGroupTypeKey = has(groupTypeTravellerMap, groupType);
    const fallback = 'family';
    const config = hasGroupTypeKey
      ? groupTypeTravellerMap[ groupType ? groupType : 'individual' ]
      : groupTypeTravellerMap[fallback];
    const travellerConfig = config[type];

    return this.getAll(type, fields).map((traveller, index) => {
      const fieldIndex = this.getIndex(traveller.id, fields);
      const isGroupTypeFamily = groupType === 'family' || groupType === 'single_parent_family';
      const travellerType = traveller.type === 'child' ? 'children' : traveller.type;
      const adultLeadMaxAge = 'products[0].metadata.age_limit.adult.lead_traveller.max_age';
      const adultLeadMinAge = 'products[0].metadata.age_limit.adult.lead_traveller.min_age';
      const maxAgePath = isGroupTypeFamily
          ? 'products[0].metadata.age_limit.family.' +travellerType + '.max_age'
          : 'products[0].metadata.age_limit.' + groupType + '.' + travellerType + '.max_age';
      const minAgePath = isGroupTypeFamily
          ? 'products[0].metadata.age_limit.family.' + travellerType + '.min_age'
          : 'products[0].metadata.age_limit.' + groupType + '.' + travellerType + '.min_age';
      const productLeadMinAge = get(branding.channel, adultLeadMinAge, 0);
      let productLeadMaxAge = get(branding.channel, adultLeadMaxAge, 79);
      const productMinAge = get(branding.channel, minAgePath, 0);
      let productMaxAge = get(branding.channel, maxAgePath, 79);

      const maxAgeYears = (maxAge, msg) => value => {
        if (!value) return undefined;
        const dob = moment(value, 'DD/MM/YYYY', true);
        if (!dob.isValid()) return undefined;

        const age = moment().diff(dob, 'years');
        return age <= maxAge ? undefined : msg;
      };

      const minAgeYears = (minAge, msg) => value => {
        if (!value) return undefined;
        const dob = moment(value, 'DD/MM/YYYY', true);
        if (!dob.isValid()) return undefined;

        const age = moment().diff(dob, 'years');
        return age >= minAge ? undefined : msg;
      };

      const isFourDigitYear = (value) => {
        if (!value) return undefined;

        const parts = value.split('/');
        if (parts.length !== 3) return 'Invalid date';

        const year = parts[2];

        if (year.length !== 4) {
          let pre: string;
          if(year < 30) {
            pre = "20";
          } else {
            pre = "19";
          }
          const example = pre+year;

          if(year.length === 2) {
            return 'Please enter the full 4-digit year e.g. ' + example;
          }

          return 'Please enter the full 4-digit year e.g. 1999';
        }

        return undefined;
      };

      return (
        <Row className="t-container" key={index}>
          <Col sm={12}>
            <Col sm={12} className="traveller margin-top">
              {index === 0 && type === 'adult' && (<h4>{branding.channel.key === 'camc-b2c' ? 'Lead Traveller' : i18n.quote.tripDetails.traveller.lead}</h4>)}
              {(index > 0 || type !== 'adult') && (<h4>{i18n.quote.tripDetails.traveller[type]} {index + 1}</h4>)}
              <div className="trash-btn">
                <Button
                  bsStyle="primary"
                  onClick={this.handleRemoveField(traveller.id, fields)}
                  className={index <= (travellerConfig.min - 1) ? 'hidden' : ''}
                >
                  <FaTrash />
                </Button>
              </div>
              <Row>
                <Col sm={12}>
                  {branding.channel.key === 'camc-b2c' ? (
                      <FormGroup controlId="name">
                        <Row>
                          <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                            <Field
                                name={`travellers[${fieldIndex}].title`}
                                id={`travellers[${fieldIndex}].title`}
                                placeholder="Title"
                                options={type === 'adult' ? adultTitles : childTitles}
                                component={SelectControl}
                                clearable={false}
                                validate={[isRequired]}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                            <Field
                                name={`travellers[${fieldIndex}].firstName`}
                                type="text"
                                placeholder="First name"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={6} style={{marginLeft: '15px', marginTop: '10px', marginBottom: '10px'}}>
                            <Field
                                name={`travellers[${fieldIndex}].lastName`}
                                type="text"
                                placeholder="Surname"
                                component={FieldFormControl}
                                validate={[isRequired]}
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                  ) : (
                      <FormGroup controlId="name">
                        <Col componentClass={ControlLabel} sm={3}>
                          *{i18n.quote.tripDetails.traveller.name}:
                        </Col>
                        <Col sm={2}>
                          <Field
                              name={`travellers[${fieldIndex}].title`}
                              id={`travellers[${fieldIndex}].title`}
                              placeholder="Title"
                              options={type === 'adult' ? adultTitles : childTitles}
                              component={SelectControl}
                              clearable={false}
                              validate={[isRequired]}
                          />
                        </Col>
                        <Col sm={4}>
                          <Field
                              name={`travellers[${fieldIndex}].firstName`}
                              type="text"
                              placeholder="First Name"
                              component={FieldFormControl}
                              validate={[isRequired]}
                          />
                        </Col>
                        <Col sm={3}>
                          <Field
                              name={`travellers[${fieldIndex}].lastName`}
                              type="text"
                              placeholder="Last Name"
                              component={FieldFormControl}
                              validate={[isRequired]}
                          />
                        </Col>
                      </FormGroup>
                  )}

                </Col>
                {branding.channel.key === 'camc-b2c' ? (
                  <Col sm={12}>
                    <FormGroup controlId="dob">
                      <Row>
                        <Col sm={6} style={{marginLeft: '15px', marginBottom: '10px'}}>
                          <Field
                              name={`travellers[${fieldIndex}].dob`}
                              type="masked-date"
                              component={FieldFormControl}
                              placeholder="Date of birth"
                              className="form-control"
                              validate={[
                                isRequired,
                                isValidDate,
                                isFourDigitYear,
                                maxAgeYears(
                                    index === 0 && type === 'adult' ? productLeadMaxAge : productMaxAge,
                                    'Sorry we cannot provide a quote due to your age.'
                                ),
                                minAgeYears(
                                    index === 0 && type === 'adult' ? productLeadMinAge : productMinAge,
                                    'Sorry we cannot provide a quote due to your age.'
                                ),
                              ]}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                ) : (
                    <Col sm={12}>
                      <FormGroup controlId="dob">
                        <Col componentClass={ControlLabel} sm={3}>
                          *{i18n.quote.tripDetails.traveller.dob}:
                        </Col>
                        <Col sm={4}>
                          <Field
                              name={`travellers[${fieldIndex}].dob`}
                              type="masked-date"
                              component={FieldFormControl}
                              placeholder="dd/mm/yyyy"
                              className="form-control"
                              validate={[
                                isRequired,
                                isValidDate,
                                isFourDigitYear,
                                maxAgeYears(
                                    index === 0 && type === 'adult' ? productLeadMaxAge : productMaxAge,
                                    'Sorry we cannot provide a quote due to your age.'
                                ),
                                minAgeYears(
                                    index === 0 && type === 'adult' ? productLeadMinAge : productMinAge,
                                    'Sorry we cannot provide a quote due to your age.'
                                ),
                              ]}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                )}
                {index === 0 && type === 'adult' && this.renderLeadTravellerFields(traveller, fieldIndex)}
                {index === 0 && type === 'child' && groupType === 'independent_child' &&
                this.renderLeadTravellerFields(traveller, fieldIndex)}
              </Row>
            </Col>
          </Col>
        </Row>
      );
    });
  }

  public componentWillMount() {
    const { fields } = this.props;
    const fieldLength = fields.length;

    if (fieldLength === 0) {
      this.addField('adult', fields);
    }
  }

  public render() {
    const { i18n, fields, groupType, branding } = this.props;
    const hasGroupTypeKey = has(groupTypeTravellerMap, groupType);
    const fallback = 'family';
    const config = hasGroupTypeKey
      ? groupTypeTravellerMap[ groupType ? groupType : 'individual' ]
      : groupTypeTravellerMap[fallback];

    let showAdultButton = (groupType === 'individual');
    if(branding.channel.key === 'csis-b2c') {
      showAdultButton = (groupType !== 'individual')
    }


    const showChildButton = (groupType !== 'individual' && groupType !== 'couple');

    return (
      <div className="section">
        <Row>
          {!hasGroupTypeKey && (
            <Alert bsStyle="danger">
              Invalid group type.
            </Alert>
          )}
          <div className="traveller-section">
            {this.renderFields('adult')}
          </div>
          {branding.channel.channelType !== 'AGG' && showAdultButton && (
            <Button
              bsStyle="primary"
              id="add-adult"
              onClick={this.handleAddField('adult', fields)}
              className={this.count('adult', fields) >= config.adult.max ? 'hidden' : ''}
            >
              {i18n.quote.button.adult}

            </Button>
          )}

          <div className={config.child.max === 0 ? 'hidden' : 'margin-top'}>
            <div className="traveller-section">
              {this.renderFields('child')}
            </div>
            {branding.channel.channelType !== 'AGG' && showChildButton && (
              <Button
                bsStyle="primary"
                id="add-child btn-remove-border"
                onClick={this.handleAddField('child', fields)}
                className={this.count('child', fields) >= config.child.max ? 'hidden' : ''}
              >
                {i18n.quote.button.child}
              </Button>
            )}
          </div>
        </Row>
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const groupType = selector(state, 'groupType');
      const tripType = selector(state, 'tripType');
      const travellers = selector(state, 'travellers');

      return {
        groupType,
        tripType,
        travellers,
        branding: state.branding,
      };
    },
  ),
])(Travellers);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetailsJourneyB/components/Travellers/index.tsx